import React from "react";

import './answerOptionItem.scss';

const AnswerOptionItem = (props) => {
    const { 
        votePercentage, 
        pollOption, 
        toggleDisplay, 
        selectionState, 
        handleClick 
    } = props;

    const percentageFill = (votePercentage) => {
        let percentFill = votePercentage;

        if (votePercentage === 0) {
            percentFill = 0
        } else if (votePercentage > 0 && votePercentage < 10) {
            percentFill = 10;
        }

        return percentFill;
    }

    const fillStyles = {
        width: `${percentageFill(votePercentage)}%`
    }

    return (
        <div className='answer-option-item-container'>
            <div className={`answer-option-item ${selectionState(pollOption.id)}`}
                id={pollOption.id}
                onClick={() => handleClick(pollOption)}>

                <div className='content-container'>
                    <p className='answer-text'>{pollOption.text}</p>
                    <p className='vote-percentage' id={toggleDisplay()}>{`${votePercentage}%`}</p>
                </div>

                <div className='fill-container'>
                    <div className='fill' id={toggleDisplay()} style={fillStyles}></div>
                </div>
            </div>
        </div>
    );
  };
  
  export default AnswerOptionItem;